'use client';

import { Button } from '@get-mosh/msh-shared';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import EventNames from 'src/analytics/EventNames';
import { trackClick } from 'src/analytics/Events';
import classNames from 'classnames';

/**
 * Props for `ButtonSection`.
 */
export type ButtonSectionProps =
    SliceComponentProps<Content.ButtonSectionSlice>;

/**
 * Component for "ButtonSection" Slices.
 */
const ButtonSection = ({ slice }: ButtonSectionProps): JSX.Element => {
    return (
        <section
            className={classNames('gap-2 space-y-2 pb-8 md:pb-16', {
                [`bg-${slice.primary.background}`]: slice.primary.background,
            })}
        >
            <div className="flex flex-row items-center justify-center md:flex-col">
                <div className="flex flex-col gap-2 md:flex-row-reverse">
                    {slice.primary.primary_label ? (
                        <Button
                            as="a"
                            text={slice.primary.primary_label || 'Button'}
                            href={slice.primary.primary_link || '/'}
                            onClick={() => {
                                trackClick(EventNames.BUTTON_CLICKED, {
                                    label:
                                        slice.primary.primary_label || 'Button',
                                    link: slice.primary.primary_link || '/',
                                    variation: slice.variation,
                                    location: slice.slice_type,
                                });
                            }}
                            stretch
                        />
                    ) : null}
                    {slice.primary.secondary_label ? (
                        <Button
                            as="a"
                            text={slice.primary.secondary_label || 'Button'}
                            href={slice.primary.secondary_link || '/'}
                            onClick={() => {
                                trackClick(EventNames.BUTTON_CLICKED, {
                                    label:
                                        slice.primary.secondary_label ||
                                        'Button',
                                    link: slice.primary.secondary_link || '/',
                                    variation: slice.variation,
                                    location: slice.slice_type,
                                });
                            }}
                            variant="secondary"
                            stretch
                        />
                    ) : null}
                </div>
            </div>
            {slice.primary.disclaimer ? (
                <p className="p2 text-center text-grey-400">
                    {slice.primary.disclaimer}
                </p>
            ) : null}
        </section>
    );
};

export default ButtonSection;
